import * as React from 'react';
import classNames from 'classnames';
import { ITimerOptions } from './TimerOptions';

export interface IClockProps {
  options: ITimerOptions;
  started?: boolean;
  onEnd(): void;
}

export interface IClockState {
  intervalHandle?: NodeJS.Timer;
}

const TICK_MS = 100;

export default class Clock extends React.Component<IClockProps, IClockState> {

  constructor(props: IClockProps) {
    super(props);
    this.state = {
      intervalHandle: undefined,
    }
    this.tick = this.tick.bind(this);
    this.getRemainingMs = this.getRemainingMs.bind(this);
    this.startIntervalIfNeeded = this.startIntervalIfNeeded.bind(this);
  }

  public render() {
    const remainingMs = this.getRemainingMs();
    const d = new Date(remainingMs);
    const time = d.toISOString().substr(11, 8);
    document.title = time;
    return (
      <div>
        <h1 
          className={classNames("display-1", {
            blink: remainingMs === 0
          })}
        >
          {time}
        </h1>
      </div>
    );
  }

  public componentDidMount() {
    this.startIntervalIfNeeded();
  }

  public componentWillUnmount() {
    if (this.state.intervalHandle) {
      clearInterval(this.state.intervalHandle);
    }
    document.title = "Date and Time Calculator";
  }

  private startIntervalIfNeeded() {
    if (!this.state.intervalHandle) {
      this.setState({
        intervalHandle: setInterval(this.tick, TICK_MS),
      });
    }
  }

  private tick() {
    if (!this.props.started) {
      return;
    }
    const remainingMs = this.getRemainingMs();
    if (remainingMs <= 0 && this.state.intervalHandle) {
      this.props.onEnd();
    } else {
      // rerender
      this.setState(this.state);
    }
  }

  private getRemainingMs() {
    const started = this.props.options.startedMs;
    const remain = this.props.options.duration - (new Date().getTime() - started);
    if (remain < 0) {
      return 0;
    }
    return remain;
  }
}



// WEBPACK FOOTER //
// ./src/Timer/Clock.tsx